import React, { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import NuAmount from "../../../../../Components/Utils/NuAmount";

function Sales() {
  const [params, setParams] = useState({
    period: "monthly",
  });

  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/targetBySalesMen`, params);
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");

  const chartData = data?.targets?.map((target) => ({
    name: target?.salesman || "N/A",
    Target: target?.target || 0,
    Achieved: target?.price || 0,
  })) || [];

  const hanChange = (e) => {
    setParams({
      period: e.target.value,
    });
    setSelectedPeriod(e.target.value);
  };

  const periods = [
    { value: "monthly", option: "Monthly" },
    { value: "quarterly", option: "Quarterly" },
    { value: "halfyearly", option: "Half Yearly" },
    { value: "yearly", option: "Yearly" },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-900 text-white shadow-xl rounded-xl p-3 text-xs border border-gray-700">
          <p className="font-semibold text-gray-300 mb-1">{payload[0]?.payload?.name}</p>
          <div className="space-y-1">
            <p className="text-purple-400 font-medium">
              Target: <NuAmount value={payload[0]?.value || 0} />
            </p>
            <p className="text-emerald-400 font-medium">
              Achieved: <NuAmount value={payload[1]?.value || 0} />
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Target vs Achieved Sales</h3>
        </div>

        <select
          value={selectedPeriod}
          onChange={hanChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
        >
          {periods.map((period) => (
            <option key={period.value} value={period.value}>
              {period.option}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-64 flex items-center justify-center animate-pulse">
          <div className="h-40 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="h-64 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#6B7280" }} />
              <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#6B7280" }} />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(243, 244, 246, 0.6)" }} />
              <Legend wrapperStyle={{ fontSize: "11px", paddingTop: "8px" }} />
              <Bar dataKey="Target" fill="#8B5CF6" radius={[6, 6, 0, 0]} barSize={14} />
              <Bar dataKey="Achieved" fill="#10B981" radius={[6, 6, 0, 0]} barSize={14} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}

export default Sales;
